<template>
  <div class="" style="padding-top: 1rem;">
    <!-- <div class="top_title fixed">我要充值</div> -->
    
    <margin-recharge />
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {},
  watch: {},
}
</script>

<style lang="less" scoped></style>
